module.exports = "<!-- <div class=\"logo\" [style.background-image]=\"backgroundImg\" routerLink=\"/home\">\r\n</div> -->\r\n\r\n<img class=\"logo\" [src]=\"backgroundImg\" routerLink=\"/home\" />"


//////////////////
// WEBPACK FOOTER
// A:/Work/Siti/Volpe2/src/app/themes/default/html/tnsiteheaderlogo.component.html
// module id = ../../../../../src/app/themes/default/html/tnsiteheaderlogo.component.html
// module chunks = 1